export const UNICODE_CHAR = {
  nbsp: '\u00A0',
  thin_space: '\u2009',
  narrow_non_breaking_space: '\u202F',
} as const
